module.exports = __webpack_public_path__ + "img/softgrove-4.1d072527.jpeg";